import { createMarkerStore, type MarkerStore } from "./markerStoreFactory";

export type CameraProbeMarkerStore = MarkerStore;

export const useCameraProbeMarkerStore = createMarkerStore();

export const useCameraProbeMarkerVisible = () =>
  useCameraProbeMarkerStore((state) => state.markerVisible);
export const useCameraProbeMarkerWorld = () =>
  useCameraProbeMarkerStore((state) => state.markerWorld);
export const useCameraProbeMarkerActions = () =>
  useCameraProbeMarkerStore((state) => state.actions);

export const getCameraProbeMarkerState = () => {
  const { actions, ...state } = useCameraProbeMarkerStore.getState();
  return state;
};

export const getCameraProbeMarkerActions = () => useCameraProbeMarkerStore.getState().actions;
